import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import VideoJS from "../../Components/VideoJsPlayer/VideoJS";
import { convertAdUrl, getEventInfo, imageUrlCheck, onVideoPlayFunction } from "../../utils/utils";
import { getLiveInfo, getVideoDetails } from "./service";
import { ReactComponent as LeftArrow } from "../../assets/Icons/leftArrow.svg";
import { getPlayerToken, getUserSubscription, authenticate } from "../../network/service";
import { getVideoSubscription } from "../Subscription/service";
import { getUserSubscriptionData } from "../../Redux/UserSubscriptionDetails/userSubscriptionSlice";
import { getMoreInfoOther } from "../../Redux/MoreInfo/moreInfoOtherSlice";
import { getMoreInfo } from "../../Redux/MoreInfo/moreInfoSlice";
import { getUser } from "../../Redux/UserSlice/UserSlice";
import { getAccessToken } from "../../Redux/AToken/ATokenSlice";
import Comment from "./Components/Comment";
import Loading from "../../Components/Loading/Loading";
import { toast } from "react-toastify";
import parse from "html-react-parser";
import ShowsRow from "../../Components/ShowsRow/ShowsRow";
import ShowCard from "../../Components/ShowCard/ShowCard";
import PlayNextEpisode from "../../Components/Modals/PlayNextEpisode";
import WatchWithoutAdsModal from '../../Components/Modals/WatchWithoutAdsModal';
import ContinueWatchingModel from "../../Components/Modals/ContinueWatchingModel";
import Autoplay from "./Components/Autoplay";
import Translate from "../../Components/MultiLanguage/Translate";
import LogoutAllModal from "../../Components/Modals/LogoutAllModal";
import AgeConfirmModal from "../../Components/Modals/AgeConfirmModal";
import { isAgeConfirmedForSession } from "../../utils/ageConfirmation";
let debounce = true;
var videoStarted = false;
let seconds = 60;
let prevTime;
let videoPlaying = false;

const Videoplayer = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const sessionId = useSelector((state) => state?.sessionId?.value);
  const user = useSelector((state) => state?.user?.value);
  const isMoreInfoOther = useSelector((state) => state?.moreInfoOther?.value);

  const [vPlayer, setVPlayer] = useState();
  const [videoUrl, setVideoUrl] = useState("");
  const [watchedDuration, setWatchedDuration] = useState();
  const [adUrl, setAdUrl] = useState();
  const [loading, setLoading] = useState(true);
  const [subtitleInfo, setSubTitleInfo] = useState();
  const [closedCaptionInfo, setClosedCaptionInfo] = useState();
  const [videoDetails, setVideoDetails] = useState({});
  const [subscriptions, setSubscriptions] = useState();
  const [watchListStatus, setWatchListStatus] = useState();
  const [isAutoplayView, setIsAutoplayView] = useState(false);
  const [watchWithoutAds, setWatchWithoutAds] = useState(false);
  const [isContinueWatchingModal, setIsContinueWatchingModal] = useState(false)
  const [selectedAudioLanguage, setSelectedAudioLanguage] = useState({})
  const [multiLanguageOptions, setMultiLanguageOptions] = useState([])
  const [upNext, setUpNext] = useState([])
  const [watchedTime, setWatchedTime] = useState(0)
  const [videoTitle, setVideoTitle] = useState("")
  const [poster, setPoster] = useState("")
  const [userSubscriptionData, setUserSubscriptionData] = useState([]);
  const [logoutModal, setLogoutModal] = useState(false);
  const [modalType, setModalType] = useState({ type: "logoutAll" });
  const [showAgeConfirmModal, setShowAgeConfirmModal] = useState(false);

  const onAgeConfirmed = () => {
    setShowAgeConfirmModal(false);
    handleVideoPlayback();
  };

  const onAgeDeclined = () => {
    setShowAgeConfirmModal(false);
    goBack();
  };

  const { } = useParams();
  const location = useLocation();
  const isLive = location?.state?.isLive;
  const eventId = location?.state?.eventId;
  const showDetails = location?.state?.showDetails
  const previousUrl = location?.state?.prevLocation ? location?.state?.prevLocation : "/home";
  const videoType = location?.state?.showDetails?.type === "linear_event" ? "event" : "video";
  // const databaseRef = firebase.database().ref('comment');
  const videoId = location?.state?.videoDetails.video_id;
  const showId = showDetails?.show_id;
  const { vanityUrl } = useParams();
  const playerRef = useRef(null);
  const currentAdUrlRef = useRef(null);
  let showUniqueId = isMoreInfoOther?.showId ? isMoreInfoOther?.showId : showId;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const continueWatch = location?.state?.continue;
  const watchDuration = location?.state?.videoDetails?.watched_duration;

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: 'transparent',
      '&:hover': {
        borderColor: 'grey',
      },

    }),

    menu: (provided) => ({
      ...provided,
      top: '100%',
      bottom: 'auto',
      backgroundColor: 'grey',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
    }),

    singleValue: (provided) => ({
      ...provided,
      color: 'grey',
    }),

    placeholder: (provided) => ({
      ...provided,
      color: 'white',
    }),
  };
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
    sessionId,
  };


  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
    setVPlayer(null)
    setWatchedDuration(0)
    setWatchedTime(0)
    setSelectedAudioLanguage({})
    setLoading(true)
    currentAdUrlRef.current = undefined;
    fetchVideoDetails();

  }, [location?.pathname]);

  useEffect(() => {
    window.scroll(0, 0);
    if (isLive) {
      setLoading(true);
      fetchLiveInfo();
    } else if (eventId) {
      setLoading(true);
      fetchEventInfo();
    } else if (videoDetails?.video_id) {
      if (videoDetails?.ad_link || showDetails?.ad_link) {
        setAdUrl(convertAdUrl(videoDetails, showDetails, appInfo, isLive));
      } else {
        setAdUrl(null);
      }

      if ((videoDetails?.is_mature_content === true || projectInfo?.projectConfig?.config?.IS_MATURE_CONTENT === "true") && !isAgeConfirmedForSession()) {
        setShowAgeConfirmModal(true);
      } else {
        handleVideoPlayback();
      }
    }
  }, [videoDetails, subscriptions]);

  useEffect(() => {
    setVPlayer(null);
    if ((!isContinueWatchingModal || continueWatch) && videoUrl) {
      const videoJsOptions = {
        autoplay: true,
        controls: true,
        responsive: true,
        fluid: true,
        controlBar: {
          pictureInPictureToggle: false,
        },
        sources: [
          {
            src: `${videoUrl}`,
            type: "application/x-mpegURL",
          },
        ],
        poster: poster || "",
      };

      const effectiveAdUrl = currentAdUrlRef.current !== undefined ? currentAdUrlRef.current : adUrl;  
      setVPlayer(
        <VideoJS
          options={videoJsOptions}
          onReady={handlePlayerReady}
          adUrl={effectiveAdUrl}
          subtitles={subtitleInfo}
          closedCaptions={closedCaptionInfo}
          hoverThumbnail={videoDetails?.hover_thumbnail}
          isPlaylist={videoDetails?.video_type === 'playlist'}
          isOtt={videoDetails?.video_type === 'ott'}
        />
      );
    }
  }, [videoUrl]);
  useEffect(() => {
   if (continueWatch && !watchWithoutAds && watchDuration > 0) {
        setIsContinueWatchingModal(false);
        playVideo(watchDuration);

        } else {
            //nothing to do
        }
    }, [continueWatch, watchWithoutAds, watchDuration]);

  const fetchLiveInfo = async () => {
    try {
      const response = await getLiveInfo(appInfo);
      setVideoUrl(response?.data?.data[0]?.live_link)
    } catch (err) {
      setLoading(false)
    }
  }

  const fetchEventInfo = async () => {
    try {
      const response = await getEventInfo(appInfo, eventId);
      setVideoUrl(response?.data?.data?.live_url)
      setLoading(false)
    } catch (err) {
      setLoading(false)
    }
  }
  const subscriptionCheck = (userSub, videoSub, isFreeVideo = false) => {
    if (isFreeVideo) {
      return Array.isArray(userSub) && userSub.length > 0;
    }
    return userSub?.some((user) => videoSub?.some((video) => user?.sub_id === video?.subscription_id));
  };


  const handleVideoPlayback = async () => {
     localStorage.setItem("showId", showDetails?.show_id);
     localStorage.setItem("vanityUrl", videoDetails?.vanity_url ? videoDetails?.vanity_url : videoDetails?.show_vanity_url);
        if (projectInfo?.projectConfig?.config?.REGISTRATION_MANDATORY === "true" && !user) {
            if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' && !videoDetails?.free_video) {
                navigate("/checkout", { state: { videoId: videoDetails?.video_id } });
            } else {
                navigate("/login", { state: { ...location.state, path: location?.pathname, showId: showId, isFrom: true } });
            }
            return;
        }
    if (logoutLimitCheck()) {
      return;
    }
    if (subscriptions?.length === 0) {

      if (projectInfo?.projectConfig?.config?.REGISTRATION_MANDATORY === "true") {

        if (!user) {

          if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' && !videoDetails?.free_video) {

            navigate("/checkout", { state: { ...location.state, path: location?.pathname, videoId: videoDetails?.video_id } });
          } else {

            navigate("/login", { state: { ...location.state, path: location?.pathname, showId: showId, isFrom: true } });
          }

        }
        else if (projectInfo?.projectConfig?.config?.AD_REQUIRED === "true") {
          if (subscriptionCheck(userSubscriptionData?.data, subscriptions, videoDetails?.free_video)) {
            // setAdUrl(null);
            playVideo();
          }
          else {
            // setAdUrl(convertAdUrl(videoDetails, showDetails, appInfo, isLive));
            playVideo();
          }
        } else {
          // setAdUrl(null);
          playVideo();
        }
      }
      else if (projectInfo?.projectConfig?.config?.AD_REQUIRED === "true") {
        if (userSubscriptionData?.login_needed === false) {
          handleClose();
          // setAdUrl(convertAdUrl(videoDetails, showDetails, appInfo, isLive));
          playVideo();
        } else if (userSubscriptionData?.login_needed === true) {
          setModalType({ type: "videoWatchLimitExpired" });
          setLogoutModal(true);
        }
        else {
          // setAdUrl(convertAdUrl(videoDetails, showDetails, appInfo, isLive));
          playVideo();
        }
      }
      else {
        if (userSubscriptionData?.login_needed === false) {
          handleClose();
          // setAdUrl(null);
          playVideo();
        } else if (userSubscriptionData?.login_needed === true) {
          setModalType({ type: "videoWatchLimitExpired" });
          setLogoutModal(true);
        }
        else {
          // setAdUrl(null);
          playVideo();
        }
      }
    }
    else if (subscriptions?.length > 0 && videoDetails?.free_video) {
      logoutLimitCheck();
      if (subscriptionCheck(userSubscriptionData?.data, subscriptions, videoDetails?.free_video)) {
        // setAdUrl(null);
        playVideo();
      } else {
        // setWatchWithoutAds(true);
        if (projectInfo?.projectConfig?.config?.AD_REQUIRED === "true") {
          // setAdUrl(convertAdUrl(videoDetails, showDetails, appInfo, isLive));
          playVideo();
        } else {
          // setAdUrl(null);
          playVideo();
        }
      }
    }
    else {
      logoutLimitCheck();

      if (subscriptionCheck(userSubscriptionData?.data, subscriptions, videoDetails?.free_video)) {
        // setAdUrl(null);
        playVideo();
      } else {

        if (!user) {

          if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true' && !videoDetails?.free_video) {
            await saveToLocalStorage();
            navigate("/checkout", { state: { ...location.state, path: location?.pathname, videoId: videoDetails?.video_id } });
          } else {

            navigate("/login", { state: { ...location.state, path: location?.pathname, showId: showId, isFrom: true } });
          }


        } else {

          if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED == 'true') {
            await saveToLocalStorage();
            navigate("/checkout", { state: { ...location.state, path: location?.pathname, videoId: videoDetails?.video_id } });
          } else {

            navigate("/subscription", { state: { videoId: videoDetails?.video_id } });
          }

        }
      }

    }
  };

  const saveToLocalStorage = async () => {
    localStorage.setItem("deviceType", "web");
    localStorage.setItem('redirectPath', location.pathname);
  }

  const logoutLimitCheck = () => {
    if (userSubscriptionData?.forcibleLogout === true) {
      setLogoutModal(true);
      setModalType({
        type: "logoutAll",
        heading: "You’ve reached the maximum Device limit.Do you want to logout from all devices",
      });
      return true;
    } else if (userSubscriptionData?.session_expired === true) {
      setModalType({ type: "redirect" });
      setLogoutModal(true);
      setTimeout(() => {
        handleClose();
        redirectToLogin();
      }, 1000);
      return true;
    }
    return false;
  }

  const isStartOver = location?.state?.isStartOver === true || location?.state?.continueWatch === false || location?.state?.videoDetails?.watched_duration === 0;

  const playVideo = async (watchedLength, customAdUrl = undefined) => {
    
    // if (watchedLength) {
    //   setWatchedDuration(watchedLength);
    // }
    let dur = 0;
    if (isStartOver) {
      dur = 0;
    } else if (typeof watchedLength === 'number') {
      dur = watchedLength;
    } else if (watchedLength && typeof watchedLength.watched_duration !== 'undefined') {
      dur = Number(watchedLength.watched_duration) || 0;
    } else if (videoDetails && typeof videoDetails.watched_duration !== 'undefined') {
      dur = Number(videoDetails.watched_duration) || 0;
    }
    setWatchedDuration(dur);
    
    if (customAdUrl !== undefined) {
      setAdUrl(customAdUrl);
      currentAdUrlRef.current = customAdUrl;
    }
    
    // if (videoDetails?.watched_duration > 0 && !continueWatch) {
    //   setIsContinueWatchingModal(true);
    // }
    setSubTitleInfo(videoDetails?.subtitles);
    setClosedCaptionInfo(videoDetails?.closed_captions);
    setPoster(videoDetails?.thumbnail_350_200);
    const videoTime = videoDetails?.video_time;
    const audio = videoDetails?.audio;
    startPlaying(videoTime, audio)
  };

  const startPlaying = async (videoTime, audio) => {
    const playerTokenData = await fetchPlayerToken(videoTime);

    if (playerTokenData) {
      setVPlayer(null);
      if (audio) {
        setVideoUrl(
          "https://api.gizmott.com/api/v1/playlistV2/playlist.m3u8?id=" +
          videoTime +
          "&token=" +
          playerTokenData +
          "&type=" +
          videoType +
          "&pubid=" +
          projectInfo?.projectConfig?.pubid +
          "&audio=" + audio
        );
      } else {
        setVideoUrl(
          "https://api.gizmott.com/api/v1/playlistV2/playlist.m3u8?id=" +
          videoTime +
          "&token=" +
          playerTokenData +
          "&type=" +
          videoType +
          "&pubid=" +
          projectInfo?.projectConfig?.pubid
        );
      }

    }
  }
  const fetchPlayerToken = async (videoId) => {
    const playerTokenResponse = await getPlayerToken(appInfo, videoId);
    if (playerTokenResponse?.status === 200) {
      return playerTokenResponse?.data?.data;
    }
  };

  const handlePlayerReady = (player) => {
    playerRef.current = player;
    player.on("play", () => {
      let event = videoStarted == true ? "POP09" : "POP02";
      videoStarted = true;
      videoPlaying = true;
      updateVideoAnalytics(event, player.currentTime());
    });
    player.on("loadedmetadata", () => {
      // player.pause();
      if (watchedTime > 0) {
        player.currentTime(watchedTime.toString());
        // player.play();
        // videoPlaying = true;
      } else if (watchedDuration > 0) {
        player.currentTime(watchedDuration.toString());
        // player.play();
        // videoPlaying = true;
      }
    });
    player.on("timeupdate", function (e) {
      let event = "POP03";
      videoPlaying = true;
      var hasPlayedTime = player.currentTime();
      var intPlayedTime = parseInt(hasPlayedTime, 10);
      var isSixty = intPlayedTime % seconds === 0 && intPlayedTime !== 0;
      if (isSixty && debounce) {
        debounce = false;
        prevTime = intPlayedTime;
        updateVideoAnalytics(event, player.currentTime());
      } else {
        if (debounce == false && prevTime != intPlayedTime) {
          debounce = true;
        }
      }
    });

    player.on("pause", () => {
      let event = "POP04";
      videoPlaying = true;
      updateVideoAnalytics(event, player.currentTime());
    });
    player.on("ended", () => {
      let event = "POP05";
      videoPlaying = false;
      // episodeCount = findIndex() + 1;
      updateVideoAnalytics(event, player.currentTime());
      
      if (videoDetails?.video_type === "playlist") {
        const currentIndex = videoDetails.up_next.findIndex(
          (video) => video.video_id === videoDetails.video_id
        );

        if (currentIndex < videoDetails.up_next.length - 1) {
          setIsAutoplayView(true);
        }
      }

      if (videoDetails?.video_type !== "playlist" && videoDetails?.up_next?.length > 0) {
        setIsAutoplayView(true);
      }
    });
    player.on("dispose", () => {
      videoPlaying = false;
      videoStarted = false;
      player.pause();
    });
  };

  const updateVideoAnalytics = async (event, time) => {
    const updateResponse = await onVideoPlayFunction(
      appInfo,
      videoDetails,
      event,
      time,
      "0",
      location?.state?.categories,
      showDetails?.show_id
    );
  };

  const handleErrorResponse = (response, showId) => {
    if (response?.status === 401) {
      const showVanity = response?.data?.data?.show_vanity_url || location?.state?.showDetails?.vanity_url;
      const fallbackPath = showVanity ? `/show-details/${showVanity}` : "/home";
      const resolvedPrevPath = location?.state?.prevPath || location?.state?.backURL || fallbackPath;
      navigate(projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === "true" ? "/checkout" : "/login", {
        replace: true,
        state: {
          ...location.state,
          isFree: response?.data?.data?.free_video || false,
          path: location?.pathname,
          showId: showId,
          isFrom: true,
          from: "VideoPlayer",
          prevPath: resolvedPrevPath,
          activeLogin: true,
          videoId: response?.data?.data?.video_id,
        }
      });
      return true;
    } else if (response?.status === 403) {
      const checkoutUrl = response?.data?.data?.checkout_link || response?.data?.data?.checkout_url;
      if (checkoutUrl) {
        window.open(checkoutUrl, "_self");
      } else {
        const showVanity = response?.data?.data?.show_vanity_url || location?.state?.showDetails?.vanity_url;
        const fallbackPath = showVanity ? `/show-details/${showVanity}` : "/home";
        const resolvedPrevPath = location?.state?.prevPath || location?.state?.backURL || fallbackPath;
        if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === 'true') {
        navigate("/checkout", {
          replace: true,
          state: { videoId: response?.data?.data?.video_id, isFree: response?.data?.data?.free_video || false, from: "VideoPlayer", prevPath: resolvedPrevPath }
        });
        } else {
        navigate("/subscription", {
          replace: true,
          state: { videoId: response?.data?.data?.video_id, isFree: response?.data?.data?.free_video || false, from: "VideoPlayer", prevPath: resolvedPrevPath }
        });
        }
      }
      return true;
    }
    return false;
  };

  const fetchVideoDetails = async () => {
    try {
      await fetchUserSubscriptionDetails();
      const showId = location?.state?.showId || 
                    location?.state?.showDetails?.show_id || null;
                    // localStorage.getItem("showId");
      
      if (showId) {
        localStorage.setItem("showId", showId);
      }
      
      const response = await getVideoDetails(appInfo, vanityUrl, showId);
      if (handleErrorResponse(response, showId)) {
        return;
      }
      if (response?.status === 200) {
        setMultiLanguageOptions(response.data.data.audio_languages);
        const videoSubResponse = await fetchVideoSubscription(response?.data?.data?.video_id);
        if (videoSubResponse?.status === 200) {
          setVideoDetails(response?.data?.data);
          setVideoTitle(response?.data?.data?.video_title)
          setUpNext(response?.data?.data?.up_next)
          setSubscriptions(videoSubResponse?.data?.data);
          setLoading(false)
          if (response?.data?.data?.watchlist_flag === 1) setWatchListStatus("added");
        } else {
          setWatchListStatus("removed");
        }
        // if (response?.data?.data?.watched_duration > 0 && !continueWatch) {
        //       setIsContinueWatchingModal(true);
        //   }
      }
    } catch (err) {
      setLoading(false);
    }
  };

  const createVideoUrl = async (video) => {
    const response = await getVideoDetails(appInfo, video?.value);
    response?.data?.data?.up_next && setUpNext(response?.data?.data?.up_next)
    const videoTime = response?.data?.data?.video_time;
    const audio = response?.data?.data?.audio
    const playerTokenData = await fetchPlayerToken(videoTime);
    if (playerTokenData) {
      setVPlayer(null);
      setVideoUrl(
        "https://api.gizmott.com/api/v1/playlistV2/playlist.m3u8?id=" +
        videoTime +
        "&token=" +
        playerTokenData +
        "&type=" +
        videoType +
        "&pubid=" +
        projectInfo?.projectConfig?.pubid +
        "&audio=" +
        audio
      );
    }
  }

  const multiAudioDropdownHandler = async (selectedOption) => {
    setSelectedAudioLanguage({ value: selectedOption.label, label: selectedOption.label, video_name: selectedOption.video_name })
    setWatchedTime(playerRef.current.currentTime())
    setVideoTitle(selectedOption.video_title)
    startPlaying(selectedOption.video_time, selectedOption.audio)

  }

  const fetchUserSubscriptionDetails = async () => {
    const userSubResponse = await getUserSubscription(appInfo);
    if (userSubResponse?.status === 200) {
      setUserSubscriptionData(userSubResponse?.data);
      dispatch(
        getUserSubscriptionData({
          userSubscription: userSubResponse?.data,
        })
      );
    }
  };

  const fetchVideoSubscription = async (videoId) => {
    const type = "video";
    try {
      return await getVideoSubscription(appInfo, videoId, type);
    } catch (err) { }
  };
  const handleClose = () => {
    document.body.className = "hideScroll";
    if (isMoreInfoOther?.isModal) {
      if (isMoreInfoOther?.isFromSearch) {
        if (location?.state?.isFromHome) {
          navigate("/home");
        }
        setTimeout(() => {
          dispatch(
            getMoreInfoOther({
              isModal: false,
              showId: null,
              isFromSearch: false,
            })
          );
        }, 600);
      } else {
        setTimeout(() => {
          dispatch(
            getMoreInfoOther({
              isModal: false,
              showId: null,
            })
          );
        }, 600);
      }
    } else {
      setTimeout(() => {
        dispatch(
          getMoreInfo({
            moreInfo: false,
          })
        );
      }, 500);
    }

  };

  const searchHandler = (value, type) => {
    navigate(`/search?query=${value}`, { state: { type } });
  };
  const redirectToLogin = () => {
    dispatch(
      getUser({
        user: null,
      })
    );
    localStorage.removeItem("userId");
    tokenAuthenticate();
    navigate("/login", {
      state: { ...location?.state, path: location?.pathname, showId: showUniqueId },
    });
  };
  const tokenAuthenticate = async () => {
    const response = await authenticate(appInfo);
    if (response?.status === 200) {
      dispatch(
        getAccessToken({
          accessToken: response?.data?.token,
        })
      );
    }
  };



  const goBack = () => {
    window.history.back();
  };

  const handlePlaylistVideoChange = async (newVideo) => {
    setVPlayer(null);

    try {
      const showId = location?.state?.showId || 
                    location?.state?.showDetails?.show_id || 
                    videoDetails?.show_id || null;
                    // localStorage.getItem("showId");
      
      if (showId) {
        localStorage.setItem("showId", showId);
      }
      
      const response = await getVideoDetails(appInfo, newVideo.vanity_url, showId);
      if (handleErrorResponse(response, showId)) {
        return;
      }
      if (response?.status === 200) {
        const freshVideoData = {
          ...response.data.data,
          video_type: 'playlist',
          vanity_url: response.data.data.vanity_url || newVideo.vanity_url,
          show_id: showId || response.data.data.show_id
        };

        setVideoDetails(freshVideoData);
        setVideoTitle(freshVideoData.video_title);
        setPoster(freshVideoData.thumbnail_350_200);
        setWatchedTime(0);
        setWatchedDuration(0);
        setUpNext(freshVideoData.up_next || []);
        setMultiLanguageOptions(freshVideoData.audio_languages || []);
        setSubTitleInfo(freshVideoData.subtitles);
        setClosedCaptionInfo(freshVideoData.closed_captions);

        try {
          const videoSubResponse = await fetchVideoSubscription(freshVideoData.video_id);
          if (videoSubResponse?.status === 200) {
            setSubscriptions(videoSubResponse?.data?.data);
          } else {
            setSubscriptions([]);
          }
        } catch (subError) {
          console.error("Error fetching subscription details:", subError);
          setSubscriptions([]);
        }

        const vanityUrl = freshVideoData.vanity_url || newVideo.vanity_url;
        window.history.replaceState(
          { 
            videoDetails: freshVideoData, 
            showId: freshVideoData.show_id,
            showDetails: { show_id: freshVideoData.show_id }
          },
          '',
          `/videos/${vanityUrl}`
        );

        const videoTime = freshVideoData?.video_time || 0;
        const audio = freshVideoData?.audio;
        startPlaying(videoTime, audio);
      }
    } catch (error) {
      console.error("Error fetching video details:", error);

      const updatedVideo = {
        ...newVideo,
        video_type: 'playlist',
        show_id: showId || newVideo.show_id
      };

      setVideoDetails(updatedVideo);
      setVideoTitle(updatedVideo.video_title);
      setPoster(updatedVideo.thumbnail_350_200);

      try {
        const videoSubResponse = await fetchVideoSubscription(updatedVideo.video_id);
        if (videoSubResponse?.status === 200) {
          setSubscriptions(videoSubResponse?.data?.data);
        } else {
          setSubscriptions([]);
        }
      } catch (subError) {
        console.error("Error fetching subscription details:", subError);
        setSubscriptions([]);
      }

      const vanityUrl = updatedVideo.vanity_url || newVideo.vanity_url;
      window.history.replaceState(
        { videoDetails: updatedVideo, showId: updatedVideo.show_id },
        '',
        `/videos/${vanityUrl}`
      );

      const videoTime = updatedVideo?.video_time || 0;
      const audio = updatedVideo?.audio;
      startPlaying(videoTime, audio);
    }
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <div className="videoPlayerContainer">
      <div className="wrapper">

        {/* {watchWithoutAds && (
          <WatchWithoutAdsModal
            setWatchWithoutAds={setWatchWithoutAds}
            showDetails={showDetails}
            appInfo={appInfo}
            setAdUrl={setAdUrl}
            videoDetails={videoDetails}
            playVideo={playVideo}
            setIsContinueWatching={setIsContinueWatchingModal}
          />
        )}
        {!continueWatch && !watchWithoutAds && isContinueWatchingModal && (
          <ContinueWatchingModel
            setIsContinueWatchingModal={setIsContinueWatchingModal}
            videoDetails={videoDetails}
            playVideo={playVideo}
            showDetails={showDetails}
            appInfo={appInfo}
            setAdUrl={setAdUrl}
          />
        )} */}
        {showAgeConfirmModal && (
          <AgeConfirmModal onConfirm={onAgeConfirmed} onCancel={onAgeDeclined} />
        )}
        {logoutModal && (
          <LogoutAllModal
            showId={showUniqueId}
            appInfo={appInfo}
            setLogoutModal={setLogoutModal}
            modalType={modalType}
            videoDetails={videoDetails}
            handleClose={handleClose}
          />
        )}
        <div className="arrowContainer" onClick={goBack}>
          <h3>
            <LeftArrow />
          </h3>
        </div>

        <div className={`topContainer ${videoDetails?.video_type === 'playlist' ? "playlist" : ""}`}>
          <div className={`playerContainer ${videoDetails?.video_type === 'playlist' ? "playlist" : ""}`}>
            { !isContinueWatchingModal && vPlayer && (
              <>
                {videoDetails?.watermark && (
                  <img
                    src={videoDetails.watermark}
                    alt="Watermark"
                    className="watermark"
                  />
                )}
                {vPlayer}
              </>
            )}
            {
              isAutoplayView &&
              <Autoplay 
                episodes={videoDetails?.up_next} 
                setIsAutoplayView={setIsAutoplayView}
                isPlaylist={videoDetails?.video_type === 'playlist'} 
                onVideoChange={handlePlaylistVideoChange} 
                currentVideoId={videoDetails?.video_id}
              />
            }
          </div>
          {videoDetails?.video_type === 'playlist' && (
            <div className="upNextSidebar">
              <h1 className="heading">
                {upNext?.length} <Translate textKey={'videos'} />
              </h1>
              <div className="upNextList">
                {upNext?.map((video) => (
                  <div
                    className={`upNextItem ${video.video_id === videoDetails.video_id ? "selected" : ""}`}
                    key={video.id}
                    onClick={() => handlePlaylistVideoChange(video)}
                  >
                    <div className='upNextTop'>
                      <div className="upNextThumbnail">
                        <img
                          src={video.thumbnail_350_200}
                          alt={video.video_title}
                        />
                      </div>
                      <div className="metaData">
                        <div className="upNextTitle">
                          {video?.video_title}
                        </div>
                        <div className="upNextDuration">
                          {video?.duration_text}
                        </div>
                      </div>
                    </div>
                    <div className={`upNextDescription ${video.video_id === videoDetails.video_id ? "visible" : ""}`}>
                      {video?.video_description && parse(video?.video_description?.split("\n")?.join("<br>"))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className="multiAudio" >
          {multiLanguageOptions?.length > 1 &&
            <div className="selectContainer">
              <Select
                styles={customStyles}
                options={multiLanguageOptions.map((video) => ({
                  value: video.language_name,
                  label: video.language_name,
                  video_name: video.video_name,
                  video_title: video.video_title,
                  video_time: video.video_time,
                  audio: video.audio
                }))}
                placeholder={multiLanguageOptions[0]?.language_name}
                onChange={multiAudioDropdownHandler}
                value={selectedAudioLanguage && Object.keys(selectedAudioLanguage)?.length !== 0 ? selectedAudioLanguage : null}
              />
            </div>}
        </div>
        <div className="videoMetaData">
          <div className="head">
            <h1 className="videoTitle">{videoTitle}</h1>
          </div>
          <div className="categoriesAndRating">
            <div className="categories">
              {videoDetails?.category_name?.map((item, index) => (
                <span className="category">{item}</span>
              ))}
            </div>

            {/* <span className="rating">PG</span> */}
          </div>
          <p className="description">
            {videoDetails?.video_description && parse(videoDetails?.video_description?.split("\n")?.join("<br>"))}
          </p>

          {videoDetails?.go_ads_free && (
            <div className="watchNow" style={{ marginTop: '15px', marginBottom: '15px' }}>
              <button
                style={{
                  width: 'fit-content',
                  minWidth: '140px',
                  backgroundColor: projectInfo?.projectConfig?.config?.BUTTON_COLOR || 'var(--button-color, var(--primary-btn-color))',
                  color: projectInfo?.projectConfig?.config?.BUTTON_TEXT_COLOR || 'var(--button-text-color, var(--white-color))',
                  borderColor: projectInfo?.projectConfig?.config?.BUTTON_COLOR || 'var(--button-color, var(--primary-btn-color))',
                  padding: '8px 20px',
                  borderRadius: '5px',
                  fontWeight: '600',
                  fontSize: '14px',
                  cursor: 'pointer'
                }}
                onClick={() => {
                  if (projectInfo?.projectConfig?.config?.WEBSITE_NEW_CHECKOUT_REQUIRED === 'true') {
                    navigate("/checkout", { state: { videoId: videoDetails?.video_id, is_go_ad_free: true, from: "VideoPlayer", prevPath: location?.state?.prevPath, isRental: location?.state?.isRental || false, checkoutDetails: location?.state?.checkoutDetails || {} } });
                  } else {
                    navigate("/subscription", { state: { videoId: videoDetails?.video_id, is_go_ad_free: true, from: "VideoPlayer", prevPath: location?.state?.prevPath, isRental: location?.state?.isRental || false, checkoutDetails: location?.state?.checkoutDetails || {} } });
                  }
                }}
              >
                <Translate textKey={'go_ads_free'} />
              </button>
            </div>
          )}

          <div className="extraInfoContainer">
            {videoDetails?.video_tags?.length > 0 && (
              <div className="metaItem">
                <h6 className="subHeading">Tags</h6>
                <div className="items oneRow">
                  {videoDetails?.video_tags?.length > 0 &&
                    videoDetails?.video_tags?.map((item, index) => (
                      <span className="item" onClick={() => searchHandler(item, "tags")}>
                        {item}
                        <span className="comma">,</span>
                      </span>
                    ))}
                </div>
              </div>
            )}
            {videoDetails?.cast?.length > 0 && (
              <div className="metaItem">
                <h6 className="subHeading">Cast</h6>
                <div className="items">
                  {videoDetails?.cast?.map((item, index) => (
                    <div className="item" key={item?.id}>
                      <span className="itemInfo" onClick={() => searchHandler(item?.name, "cast")}>
                        {item?.name}
                      </span>
                      <span className="itemLabel">{item?.role}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {videoDetails?.crew?.length > 0 && (
              <div className="metaItem">
                <h6 className="subHeading">Crew</h6>
                <div className="items">
                  {videoDetails?.crew?.map((item, index) => (
                    <div className="item" key={item?.id}>
                      <span className="itemInfo" onClick={() => searchHandler(item?.name, "crew")}>
                        {item?.name}
                      </span>
                      <span className="itemLabel">{item?.role}</span>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>

      </div>

      <div className="wrapper">
        {upNext?.length > 0 && videoDetails?.video_type !== 'playlist' && (
          <div className="upNextContainer">
            <h1 className="heading"><Translate textKey={'upnext'} /> {videoDetails?.season && `in Season ${videoDetails?.season}`} </h1>
            <div className="upNext" onClick={() => setIsAutoplayView(false)}>
              {upNext?.map((video) => (
                <div className={projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT" ? "itemPortrait" : "item"}>
                  <ShowCard data={video} type="Episode" />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
      {videoDetails?.files?.length > 0 && (
        <div className="wrapper">
          <div className="files">
            <ShowsRow data={videoDetails?.files} type="pdf" />
          </div>
        </div>
      )}
      <span className="line"></span>
      {projectInfo?.projectConfig?.config?.COMMENTS_REQUIRED === "true" && projectInfo?.projectConfig?.config?.WEBSITE_FIREBASE_JSON_FILE &&
        <div className="wrapper">
          <Comment videoId={videoDetails?.video_id} projectInfo={projectInfo} />
        </div>
      }
    </div>
  );
};

export default Videoplayer;